import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=7effd62c&scoped=true"
import script from "./Theory.vue?vue&type=script&lang=js"
export * from "./Theory.vue?vue&type=script&lang=js"
import style0 from "./Theory.vue?vue&type=style&index=0&id=7effd62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7effd62c",
  null
  
)

export default component.exports